// extracted by mini-css-extract-plugin
export var clickThrough = "_yu-2";
export var fallback = "_yu-5";
export var frame = "_yu-3";
export var frameCell = "_yu-1";
export var overlay = "_yu-4";
export var wrapper = "_yu-0";